import { apiGet, apiPost, apiPut } from '@gat-ship/http-client'
import type {
  GetAllSupportPersonnelResponse,
  GetSupportSessionResponse,
  GetAssignedSupportSessionRequest,
  GetRegisteredSupportSessionRequest,
  GetSupporSessionsHistoryQueryParams,
  GetSupporSessionsHistoryRequest,
  CreateNewSupportSessionRequest
} from '@gat-ship/types'
import { SUPPORT_API_PATHS } from '@gat-ship/types'

/** API calls for the support domain. */
export function useSupportApiCalls() {
  /** Get a support session by ID that is either registered by or assigned to the current user. */
  async function getAllSupportPersonnelRequest() {
    const response = await apiGet<GetAllSupportPersonnelResponse>(
      SUPPORT_API_PATHS.getAllSupportPersonnel
    )
    return response
  }

  async function getSupportSessionRequest(sessionId: string) {
    const response = await apiGet<GetSupportSessionResponse>(
      SUPPORT_API_PATHS.getSupportSession(sessionId)
    )
    return response
  }

  /** Get active support sessions that are assigned to the current user. */
  async function getAssignedSupportSessionsRequest() {
    const response = await apiGet<GetAssignedSupportSessionRequest>(
      SUPPORT_API_PATHS.getAssignedSupportSessions
    )
    return response
  }

  /** Get active support sessions that are registered by the current user. */
  async function getRegisteredSupportSessionsRequest() {
    const response = await apiGet<GetRegisteredSupportSessionRequest>(
      SUPPORT_API_PATHS.getRegisteredSupportSessions
    )
    return response
  }

  /** Get the history of support sessions. */
  async function getSupportSessionsHistoryRequest(
    query?: GetSupporSessionsHistoryQueryParams
  ) {
    const response = await apiGet<GetSupporSessionsHistoryRequest>(
      SUPPORT_API_PATHS.getSupporSessionsHistory(query)
    )
    return response
  }

  /** Creates a new support session and assign it to a given support user. */
  async function createNewSupportSessionRequest(
    payload: CreateNewSupportSessionRequest,
    commandId: string
  ) {
    const response = await apiPost(
      SUPPORT_API_PATHS.createNewSupportSession,
      payload,
      commandId
    )
    return response
  }

  /** Ends an existing support session. */
  async function endSupportSessionRequest(
    sessionId: string,
    commandId: string
  ) {
    const response = await apiPut(
      SUPPORT_API_PATHS.endSupportSession(sessionId),
      {},
      commandId
    )
    return response
  }

  return {
    getAllSupportPersonnelRequest,
    getSupportSessionRequest,
    getAssignedSupportSessionsRequest,
    getRegisteredSupportSessionsRequest,
    getSupportSessionsHistoryRequest,
    createNewSupportSessionRequest,
    endSupportSessionRequest
  }
}
